import { attributes } from "../common/reactHelpers.jsx";
export const btn = (text, attrs = "", secondary = false) => (
  <button
    type="button"
    className={"btn " + (secondary ? "secondary" : "")}
    {...attributes(attrs)}
  >
    {text}
  </button>
);
export const field = (label, name, value = "", type = "text", extra = "") => (
  <label className="field">
    <span>{label}</span>
    <input
      key={name + "-" + value}
      name={name}
      type={type}
      defaultValue={value ?? ""}
      {...attributes(extra)}
    />
  </label>
);
export const area = (label, name, value = "") => (
  <label className="field">
    <span>{label}</span>
    <textarea
      key={name + "-" + value}
      name={name}
      rows="3"
      defaultValue={value}
    />
  </label>
);
export const check = (label, name, on) => (
  <label className="check">
    <input
      key={name + "-" + !!on}
      type="checkbox"
      name={name}
      defaultChecked={!!on}
    />
    {label}
  </label>
);
export const select = (label, name, value, options) => (
  <label className="field">
    <span>{label}</span>
    <select key={name + "-" + value} name={name} defaultValue={value}>
      {options.map((o, i) => {
        const [v, t] = Array.isArray(o) ? o : [o, o];
        return (
          <option key={v || i} value={v}>
            {t}
          </option>
        );
      })}
    </select>
  </label>
);
export const errorSlot = () => (
  <p id="form-error" className="error" role="alert" tabIndex="-1" />
);
